import { render, staticRenderFns } from "./NewCombinedInput.vue?vue&type=template&id=564b367c&scoped=true"
import script from "./NewCombinedInput.vue?vue&type=script&lang=js"
export * from "./NewCombinedInput.vue?vue&type=script&lang=js"
import style0 from "./NewCombinedInput.vue?vue&type=style&index=0&id=564b367c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b367c",
  null
  
)

export default component.exports